import { i18n } from "../translate/i18n";

/* eslint-disable new-cap */
export default function formatToCurrency(value) {
  const locale = i18n.language === "pt" ? "pt-BR" : "es-MX";
  const currencySymbol = i18n.language === "pt" ? "BRL" : "MXN";
  
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencySymbol,
  }).format(value);
}
